import React, {useContext} from 'react';
import MethodsOneContext from './../Contexts/MethodsOne';
import Editor from './Editor';


function Article(props) {
 
    let { description } = props.item;
    const methodsOneContext = useContext(MethodsOneContext);
return (
  <>
 
 <article class="discuss-box    success">
     <h2 class="discuss-box--title">
         <button onClick={() => methodsOneContext.editDetail(props.item.id)} type='button'>ویرایش</button>
     </h2>  
     <div class="discuss-box--content">
                <p>{description}</p> 
        
     </div> 
     <div class="type">
         <div class="answer">۲۷ پاسخ</div>
     </div>
 </article>

  </>
) 
}

export default Article;